export const PREFIX_API = "api";
export enum ApiRoute {
  ACCOUNT = "account",
  ADMIN = "admin",
  AGENT = "agent",
  APPLICATION = "applications",
  CREDIT = "credit",
  HEALTH = "health",
  MAP = "map",
  ORG = "org",
  PROFILE = "profile",
  PROGRAM = "programs",
  PUBLIC = "public",
  PARTNER = "partner",
  REFERRAL = "referral",
  SEO = "seo"
}

export function getApiRoute(route: ApiRoute, version: string = "v1"): string {
  return `/${PREFIX_API}/${version}/${route}`;
}
